export const paymentTransactionDocumentRequestDto = (isHidden = null, category = null, note = null) => {
  return {
    hidden: isHidden,
    category,
    note
  };
};
